import { html } from 'lit';
import { CrntElement } from '../../lib/crnt-element.js';
import { trustedCSS } from '../../lib/css/css.js';
import formControlHelpTextStyles from './form-control-help-text.css.js';

class CrntFormControlHelpText extends CrntElement {
  static {
    this.styles = trustedCSS(formControlHelpTextStyles);
  }
  static {
    this.tagName = "crnt-form-control-help-text";
  }
  render() {
    return html`<slot class="crnt-form-control-help-text" part="container"></slot>`;
  }
}

export { CrntFormControlHelpText };
